// import qs from 'qs';
export default {
  data () {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    getLetterFromNumber (i) {
      switch (i) {
        case 0:
          return 'A';
        case 1:
          return 'B';
        case 2:
          return 'C';
        case 3:
          return 'D';
        case 4:
          return 'E';
        case 5:
          return 'F';
        case 6:
          return 'G';
        case 7:
          return 'H';
        case 8:
          return 'I';
        case 9:
          return 'J';
        case 10:
          return 'K';
        case 11:
          return 'L';
        case 12:
          return 'M';
        case 13:
          return 'N';
        case 14:
          return 'O';
        case 15:
          return 'P';
        case 16:
          return 'Q';
      }
    },
    getLetterFromText (i) {
      switch (i) {
        case 0:
          return '第一空答案';
        case 1:
          return '第二空答案';
        case 2:
          return '第三空答案';
        case 3:
          return '第四空答案';
        case 4:
          return '第五空答案';
        case 5:
          return '第六空答案';
        case 6:
          return '第七空答案';
        case 7:
          return '第八空答案';
        case 8:
          return '第九空答案';
        case 9:
          return '第十空答案';
        case 10:
          return '第十一空答案';
        case 11:
          return '第十二空答案';
        case 12:
          return '第十三空答案';
        case 13:
          return '第十四空答案';
        case 14:
          return '第十五空答案';
        case 15:
          return '第十六空答案';
        case 16:
          return '第十七空答案';
      }
    },
    translateSeconds (time) {
      var min = Math.floor(time % 3600);
      return Math.floor(time / 3600) + '时' + Math.floor(min / 60) + '分' + time % 60 + '秒';
    },
    formatSeconds (time) {
      var min = Math.floor(time % 3600);
      return (
        (Math.floor(time / 3600) < 10 ? '0' + Math.floor(time / 3600) : Math.floor(time / 3600)) +
        ':' +
        (Math.floor(min / 60) < 10 ? '0' + Math.floor(min / 60) : Math.floor(min / 60)) +
        ':' +
        (time % 60 < 10 ? '0' + time % 60 : time % 60)
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/letterFormat.js